import { useEffect, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getOidcTokenAndUserInfo, getTenantId } from '../api/oidcAuth';
import { oidcSignIn, signIn } from '../authenticatorSlice';

import { setOidcSignInState } from '@/app/api/baseApi';
import { SIGNIN_BACK_PATH } from '@/config';
import { AUTH_COOKIES } from '@/constants';
import { serviceProfile as jsonServiceProfile } from '@/profile/serviceProfile';
import { CUCON_API_KEY_NAME, getToken } from '@/utils/storage';

export function GetToken() {
  const [, setCookie, removeCookie] = useCookies(AUTH_COOKIES);
  const navigate = useNavigate();
  const processingRef = useRef(false); // 重複実行防止フラグ
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchToken = async () => {
      if (processingRef.current) return; // 重複実行防止
      processingRef.current = true;

      const tokenAndUserInfo = await getOidcTokenAndUserInfo();
      if (tokenAndUserInfo) {
        const apiKey =
          jsonServiceProfile?.cuconConfig?.apiKey ??
          getToken(CUCON_API_KEY_NAME);
        const tenantId = getTenantId(apiKey);
        setOidcSignInState(
          true,
          tokenAndUserInfo.accessToken ?? '',
          tokenAndUserInfo.refreshToken ?? '',
          tenantId
        );
        setCookie('accessToken', tokenAndUserInfo.accessToken, { path: '/' });
        setCookie('refreshToken', tokenAndUserInfo.refreshToken, { path: '/' });
        dispatch(
          signIn({
            id: tokenAndUserInfo.userId,
            username: tokenAndUserInfo.username,
            userGroupName: '',
            name: tokenAndUserInfo.name,
          })
        );
        dispatch(oidcSignIn());
      } else {
        removeCookie('accessToken', { path: '/' });
        removeCookie('refreshToken', { path: '/' });
      }

      const singninBackPath =
        sessionStorage.getItem(SIGNIN_BACK_PATH) ?? undefined;
      if (singninBackPath !== undefined) {
        sessionStorage.removeItem(SIGNIN_BACK_PATH);
        navigate(singninBackPath);
      } else {
        navigate('/');
      }
    };
    fetchToken();
  }, [dispatch, navigate, removeCookie, setCookie]);

  return null;
}
